<div class="b-input__table">
  <div class="b-input__table-td">
    <label class="b-input__label" [innerHTML]="label" [attr.for]="id"></label>
    <input #i [id]="id" [name]="name" [type]="type" class="b-input__input b-input__text-input"
      [style.width]="'calc(100% + 40px)'" [attr.list]="autoId" [disabled]="disabled"
      [placeholder]="hasLabel ? '' : placeholder" [(ngModel)]="value" (keydown)="keydown($event)"
      (keyup)="actionKeyup($event)" (input)="actionChange()" (focus)="onFocus($event)" (click)="checkIfActive()"
      (blur)="actionBlur($event)" />
    <datalist *ngIf="!customDropdown" [id]="autoId">
      <option *ngFor="let o of textList; trackBy: trackByValue" [value]="o"></option>
    </datalist>
  </div>
  <div [hideEmpty]="2" class="b-input__button-wrapper" #buttons>
    <ng-content select="f-facet[name=buttons],[facet-buttons]"></ng-content>
  </div>
  <div class="b-input__button-wrapper b-block--not-clickable" *ngIf="emptyButtons">
    <button w-button class="b-block--not-clickable" buttonType="dropdown" size="large"></button>
  </div>
</div>
<f-facet-info *ngIf="customDropdown && dropdownOptionList && autocompleteActive" [isDropdown]="true">
  <w-input-dropdown [list]="dropdownOptionList" [activeIndex]="activeIndex"
    (wDropdownClick)="dropdownClick($event)"></w-input-dropdown>
</f-facet-info>
<f-facet-info [isError]="true" [noMarker]="autocompleteActive">
  {{error}}<ng-content select="f-facet[name=error],[facet-error]"></ng-content>
</f-facet-info>
<f-facet-info [noMarker]="autocompleteActive">
  {{info}}<ng-content select="f-facet[name=info],[facet-info]"></ng-content>
</f-facet-info>